import { Component, forwardRef, OnInit, ViewChild, AfterViewInit, ComponentRef, Injector } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IComponentDef } from '../../../shared';

@Component({
  selector: 'app-r-groups',
  templateUrl: './r-groups.component.html',
  styles: [
    `
      .d-groups {
        min-height: 100px;
        background: #fff;
        border: 1px dashed #ccc;
        position: relative;
        z-index: 1001;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RGroupsComponent),
      multi: true
    }
  ]
})
export class RGroupsComponent extends RenderComponentBase {
  static KEY = 'r-d-group';
  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.labelPosition) {
      config.labelPosition = 'top';
    }
  }

  selectComponentChange(value) {}
}
